import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form'

import weather from './weather';
// test transit
import transit from './transit';
import stop from './stop';
import minibus from './minibus';
import municipal from './municipal';

const rootReducer = combineReducers({
  form: formReducer,
  routing: routerReducer, 
  weather,
  transit,
  stop,
  minibus,
  municipal,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js